<template>
  <multiselect-item
    id="idCliente"
    v-model="idCliente"
    :custom-label="(option) => `${option.id_cliente} - ${option.nombre_web}`"
    :options="idClienteOptions"
    :placeholder="placeholder"
    track-by="id_cliente"
    :loading="isLoading || isLoadingExternal"
  >
  </multiselect-item>
</template>
<script>
import { get } from "lodash-es";
import AdaptarVueModel from "./AdaptarVueModel";
import axios from "axios";

export default {
  name: "SelectClienteVigente",
  props: {
    value: { dafault: null },
    placeholder: {
      default: "Seleccione el cliente",
    },
    incluirSoloSinContrato: Boolean,
    idCobranzaLugarPago: {
      type: [Number, null],
      default: null,
    },
    isLoadingExternal: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [AdaptarVueModel],
  mounted() {
    this.getData();
  },
  data: () => ({
    isLoading: true,
    idClienteOptions: [],
    todosLosClientes: [],
    result: null,
  }),
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetClientesVigentesParaFiltrar",
          parameters: [],
        });

        if (get(resp, "data.ok", false)) {
          this.todosLosClientes = get(resp, "data.result[0]", []);
          this.aplicarFiltros();
        } else {
          this.$msgBoxOk(resp.data.message);
        }
        this.isLoading = false;
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
    aplicarFiltros() {
      const mostrarSinContrato = this.incluirSoloSinContrato === true;
      const idLugarPago = this.idCobranzaLugarPago;

      this.idClienteOptions = this.todosLosClientes.filter((cliente) => {
        if (mostrarSinContrato && cliente.tiene_contrato !== 0) {
          return false;
        }

        if (!mostrarSinContrato && cliente.tiene_contrato !== 1) {
          return false;
        }

        if (
          idLugarPago != null &&
          cliente.id_cobranza_lugarPago !== idLugarPago
        ) {
          return false;
        }

        return true;
      });

      this.adaptarVueModel(this.idClienteOptions, "id_cliente");
    },
  },
  computed: {
    idCliente: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    incluirSoloSinContrato() {
      this.aplicarFiltros();
    },
    idCobranzaLugarPago() {
      this.aplicarFiltros();
    },
  },
};
</script>
<style scoped></style>
